module.exports = ".ui-fluid img {\r\n    max-width:150px;\r\n    max-height:100px;\r\n    width: auto;\r\n    height: auto;\r\n}"